import { defineStore } from 'pinia'
import { IGroup } from '@/interfaces/entities/group'
import GroupResource from '@/api/resources/group'
import type { IFetchRateParams } from '@/interfaces/api/rate'
import type { IRate } from '@/interfaces/stores/rate'
import type { FareItems } from '@/interfaces/entities/fareItems'

export const useRateStore = defineStore({
  id: 'rate',
  persist: true,

  state: () => ({
    selectedGroup: {} as IGroup,
    period: [] as Date[],
    rateData: null as IRate | null,
    fareData: {} as FareItems,
  }),

  getters: {
    getPeriodFilter: (state) => state.period,
    getRateData: (state) => state.rateData,
    getFareData: (state) => state.fareData,
    amountFare: (state) => {
      return Object.values(state.fareData).reduce((sum, item) => {
        return sum + (item?.amount * item?.price_per_unit || 0)
      }, 0)
    },
  },

  actions: {
    async fetchRate(payload: IFetchRateParams) {
      try {
        const rate: IRate = await GroupResource.getGroupRate(payload)
        this.rateData = rate

        return rate
      } catch (error) {
        this.rateData = null
        throw error
      }
    },
    setGroup(group: IGroup) {
      this.selectedGroup = group
    },
    setFareData(fareData: FareItems) {
      this.fareData = fareData
    },
    resetRateData() {
      this.rateData = null
    },
  },
})
